module.exports = __webpack_public_path__ + "img/img3.8ff75a59.jpg";